import {Component, Input, OnInit} from '@angular/core'
import {OptionsNgxOwCarouselService} from 'dmmp-services'

@Component({
  selector: 'dmmp-benefits-carousel',
  templateUrl: './benefits-carousel.component.html',
})

export class BenefitsCarouselComponent implements OnInit {
  @Input() identifier
  @Input() data
  configBenefits

  constructor(private options: OptionsNgxOwCarouselService) {
  }

  ngOnInit() {
    this.configBenefits = this.options.configurationBenefits(this.data)
  }
}

